import React, { Component } from "react"
import ReactDOM from "react-dom"
import styled from "styled-components"
import { Container, Row, Col, Modal, ModalBody } from "reactstrap"
import Slider from "react-slick"
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
// import { faTimes } from "@fortawesome/pro-light-svg-icons"
import { media } from "utils/Media"
import { GatsbyImage } from "gatsby-plugin-image";
import close from "images/close.svg"

const ModalClose = styled.button`
    position: absolute;
    right: 0;
    top: -2.5rem;
    background-color: transparent;
    font-size: 2rem;
    z-index: 10;
    border: 0;
    color: ${props => props.theme.colors.white};

    @media ${media.md} {
        right: -2rem;
        top: -1rem;
    }

    /*@media ${media.lg} {
        right: 0;
        top: -3rem;
    }

    @media ${media.xl} {
        right: -2rem;
        top: -5rem;
    } */
`

const ModalStyled = styled(Modal)`

    @media ${media.xl} {
        max-width: 1200px;
    }

    div {
        outline: 0;
    }

    .modal-content {
        background: transparent;
        border: 0;

        img {
            /* max-height: 65vh;
            width: auto;
            display: block;
            margin: 0 auto; */
        } 
    }
    
    .modal-body {
        padding: 0;
    }

    .slick-arrow {
        left: -2rem;
        &:before {
            color: white;
        }

        &.slick-next {
            left: auto;
            right: -2rem;
        }
    }

    .slick-list, .slick-track, .slick-slide  {
        max-height: 600px;
    }

    .slick-track {
        display: flex;
        align-items: center;
    }

    .slider-nav {
        .slick-current {
            img { 
                border: 2px solid ${props => props.theme.colors.secondary};
            }
        }
    }
`

const ImageWrapper = styled.div`
    position: relative;
    overflow: hidden;
    width: 100%;
    margin: 0 auto;
    .gatsby-image-wrapper {
        margin: 0 auto;
    }
`

const Caption = styled.div`
    position: absolute;
    bottom: .5rem;
    color: white;
    left: 50%;
    transform: translateX(-50%);
`

class GalleryLightbox extends Component  {
    constructor(props) {
        super(props)

        this.state = {
            carouselImage: null,
            carouselNav: null,
            navItemSize: 5
        }

        this.changeImage = this.changeImage.bind(this)
        this.changeImageNav = this.changeImageNav.bind(this)
        this.navItemSize = this.navItemSize.bind(this)
        this.captionWidth = this.captionWidth.bind(this)
    }

    componentDidMount() {
        this.navItemSize() 

        this.setState({
            carouselImage: this.carouselImage,
            carouselNav: this.carouselNav
        })

        window.addEventListener("resize", this.navItemSize,  {passive: true})
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.navItemSize, { passive: true })
    }

    changeImage(current, next) {
        this.captionWidth() 
        this.carouselImage.slickGoTo(next)
    }

    changeImageNav(current, next) { 
        this.carouselNav.slickGoTo(next)
    }

    captionWidth() {
        const imageWidth = ReactDOM.findDOMNode(this.image).getBoundingClientRect().width + "px"

        this.setState({
            captionWidth: imageWidth
        })
    }

    navItemSize() {
        let size = 5
        if (window.innerWidth < 768) {
            size = 4
        }

        this.setState({
            navItemSize: size
        })
    }

    render() {

        const { images, modalOpen, toggleModal } = this.props

        const carouselImageItems = images.map((image, i) => {
            return (
                <ImageWrapper key={i}>
                    <GatsbyImage
                        image={image.localFile.childImageSharp.gatsbyImageData}
                        maxHeight="65vh"
                        ref={image => this.image = image}
                        alt={image.altText} />
                    {image.caption &&
                        <Caption dangerouslySetInnerHTML={{ __html: image.caption }} />
                    }
                </ImageWrapper>
            );
        })

        const carouselNavItems = images.map((image, i) => {

            return (
                <div key={i} className="px-1">
                    <GatsbyImage
                        image={image.localFile.childImageSharp.gatsbyImageData}
                        alt={image.altText} />
                </div>
            );
        })

        return(
            <ModalStyled isOpen={modalOpen} toggle={toggleModal} centered size="lg">
                <ModalBody>
                    <ModalClose type="button" aria-label="Close" onClick={toggleModal}>
                        {/* <FontAwesomeIcon icon={faTimes} /> */}
                        <img src={close} alt="close" />
                    </ModalClose>

                    <div className="px-4 px-md-0">
                        <Slider
                            ref={slider => (this.carouselImage = slider)}
                            asNavFor={this.state.carouselNav}
                            draggable={false}
                            swipeToSlide={true}
                            fade={true}
                            initialSlide={this.props.activeImage}
                            beforeChange={(current, next) => this.changeImageNav(current, next)}
                            // adaptiveHeight={true}
                            // lazyLoad={true}
                        >
                            {carouselImageItems}
                        </Slider>
                    </div>

                    <Container className="mt-5">
                        <Row className="justify-content-center">
                            <Col xs={10} lg={9}>
                                <Slider
                                    ref={slider => (this.carouselNav = slider)}
                                    slidesToShow={this.state.navItemSize}
                                    swipeToSlide={true}
                                    focusOnSelect={true}
                                    lazyLoad={true}
                                    beforeChange={(current, next) => this.changeImage(current, next)}
                                    className="slider-nav"
                                >
                                    {carouselNavItems}
                                </Slider>
                            </Col>
                        </Row>
                    </Container>
                </ModalBody>
            </ModalStyled>
        )
    }
}

export default GalleryLightbox